"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusIndicator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("./styles"));
exports.StatusIndicator = react_1.default.memo(function (_a) {
    var color = _a.color, _b = _a.size, size = _b === void 0 ? 'small' : _b, onClick = _a.onClick, onDelete = _a.onDelete, _c = _a.deletable, deletable = _c === void 0 ? false : _c, _d = _a.clickable, clickable = _d === void 0 ? false : _d, rest = __rest(_a, ["color", "size", "onClick", "onDelete", "deletable", "clickable"]);
    var classes = (0, styles_1.default)({ color: color });
    // NOTE: needed a more dependable way to turn off these options than the baked in MUI approach
    var onClickFunc = clickable ? onClick : undefined;
    var onDeleteFunc = deletable ? onDelete : undefined;
    return ((0, jsx_runtime_1.jsx)(core_1.Chip, __assign({ className: classes.root, size: size, onClick: onClickFunc, onDelete: onDeleteFunc }, rest)));
});
exports.StatusIndicator.displayName = 'StatusIndicator';
